import { SCOOTER_PATH } from "../map/pins";
// Inline SVG icons (no icon library, PLAN.md D5).
export const BikeIcon = (p: { size?: number; color?: string }) => (
  <svg
    width={p.size ?? 20}
    height={p.size ?? 20}
    viewBox="0 0 24 24"
    fill="none"
    stroke={p.color ?? "currentColor"}
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Vélo</title>
    <circle cx="6" cy="16" r="3.5" />
    <circle cx="18" cy="16" r="3.5" />
    <path d="M6 16l4-8h5l3 8M10 8l5 8M14 5h3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
export const BatteryIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Batterie</title>
    <rect x="3" y="7" width="16" height="10" rx="2" />
    <path d="M21 10v4" stroke-linecap="round" />
    <rect x="6" y="10" width="7" height="4" fill="currentColor" stroke="none" />
  </svg>
);
export const NavIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <title>Distance</title>
    <path d="M12 2L4 20l8-4 8 4z" />
  </svg>
);
export const PersonIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Places</title>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" stroke-linecap="round" />
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Durée</title>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" stroke-linecap="round" />
  </svg>
);
export const SpeedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Vitesse</title>
    <path d="M4 16a8 8 0 0 1 16 0" />
    <path d="M12 16l4-5" stroke-linecap="round" />
  </svg>
);
export const ScanIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    aria-hidden="true"
  >
    <title>Scanner</title>
    <path
      d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3"
      stroke-linecap="round"
    />
    <rect x="8" y="8" width="8" height="8" rx="1" />
  </svg>
);
export const MenuIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.4"
    aria-hidden="true"
  >
    <title>Menu</title>
    <path d="M4 7h16M4 12h16M4 17h16" stroke-linecap="round" />
  </svg>
);
export const LocateIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    aria-hidden="true"
  >
    <title>Ma position</title>
    <circle cx="12" cy="12" r="3" />
    <circle cx="12" cy="12" r="8" />
    <path d="M12 1v3M12 20v3M1 12h3M20 12h3" stroke-linecap="round" />
  </svg>
);
export const CheckCircle = (p: { size?: number }) => (
  <svg width={p.size ?? 24} height={p.size ?? 24} viewBox="0 0 24 24" aria-hidden="true">
    <title>OK</title>
    <circle cx="12" cy="12" r="12" fill="#95c11f" />
    <path
      d="M7 12.5l3.2 3L17 9"
      fill="none"
      stroke="#fff"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ParkingIcon = (p: { size?: number }) => (
  <svg width={p.size ?? 44} height={p.size ?? 44} viewBox="0 0 44 44" aria-hidden="true">
    <title>Stationnement</title>
    <circle cx="22" cy="22" r="20.5" fill="#fff" stroke="#321ED3" stroke-width="3" />
    <path
      fill="#321ED3"
      transform="translate(1.24 1.78) scale(1.4444)"
      d="M14.75 7.25H9.5V20.75H12.5V16.25H14.75C17.23 16.25 19.25 14.23 19.25 11.75C19.25 9.27 17.23 7.25 14.75 7.25ZM14.9 13.25H12.5V10.25H14.9C15.73 10.25 16.4 10.93 16.4 11.75C16.4 12.58 15.73 13.25 14.9 13.25Z"
    />
  </svg>
);
/** Simple side-view e-bike illustration (Figma 03, 05b). */
export const BikeArt = (p: { size?: number }) => (
  <svg
    width={p.size ?? 72}
    height={(p.size ?? 72) * 0.7}
    viewBox="0 0 100 70"
    fill="none"
    aria-hidden="true"
  >
    <title>Vélo électrique Pony</title>
    <circle cx="22" cy="50" r="15" stroke="#321e64" stroke-width="3" />
    <circle cx="78" cy="50" r="15" stroke="#321e64" stroke-width="3" />
    <path
      d="M22 50l18-26h22l16 26M40 24l12 26M62 24l-6-10h10"
      stroke="#00bcd4"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect x="34" y="16" width="12" height="5" rx="2" fill="#321e64" />
    <rect x="44" y="34" width="14" height="6" rx="2" fill="#321e64" />
  </svg>
);

// Figma "icon/face-1" … "icon/face-5" (08 Ride summary): same outline and eyes, only the mouth changes.
const FACE_MOUTHS = [
  "M12 24.75C14.25 21.75 21.75 21.75 24 24.75",
  "M12.75 24C15 22.5 21 22.5 23.25 24",
  "M12.75 23.25H23.25",
  "M12.75 21.75C15 23.25 21 23.25 23.25 21.75",
  "M12 21C14.25 24.75 21.75 24.75 24 21",
];
export const FaceIcon = (p: { level: 1 | 2 | 3 | 4 | 5; color: string }) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" aria-hidden="true">
    <circle cx="18" cy="18" r="14.25" stroke={p.color} stroke-width="1.6" />
    <circle cx="13.5" cy="15" r="1.65" fill={p.color} />
    <circle cx="22.5" cy="15" r="1.65" fill={p.color} />
    <path
      d={FACE_MOUTHS[p.level - 1]}
      stroke={p.color}
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

/** Side-view scooter illustration for the vehicle sheet, from the Pony "Icon/Scooter" glyph (20 × 18). */
export const ScooterArt = (p: { size?: number }) => (
  <svg width={p.size ?? 72} height={(p.size ?? 72) * 0.7} viewBox="0 0 100 70" aria-hidden="true">
    <title>Trottinette électrique Pony</title>
    <path
      fill="#321E64"
      fill-rule="evenodd"
      transform="translate(13 3.7) scale(3.7)"
      d={SCOOTER_PATH}
    />
  </svg>
);
